import { SkeletonSquareGrid } from "#common/Skeleton"
import { useApi } from "#hooks/useApi"
import { useAnnualPlanContext } from "#training/contexts/contexts"
import { UseReduxTraining } from "#training/redux/slice"
import { annualPlanGet } from "#training/services/Api"
import { Typography } from "@mui/material"
import { MESES } from "Components/Capacitaciones/constants_capacitaciones"
import MUIDataTable from "mui-datatables"
import { Fragment, useMemo } from "react"
import PlanningMassiveDialog from "./PlanningMassiveDialog"

const PlanningTable = () => {
	const { reload } = UseReduxTraining()
	const { filterCourses, selectCategory } = useAnnualPlanContext()
	const params = useMemo(() => ({ ...filterCourses }), [filterCourses])
	const autoFetch = useMemo(() => {
		if (filterCourses?.category && filterCourses?.area && filterCourses?.year)
			return true
		return false
	}, [filterCourses?.category, filterCourses?.area, filterCourses?.year])
	const { data, loading } = useApi(annualPlanGet, { autoFetch, params, reload })

	const columns = [
		{
			name: "Nombre",
			label: "Nombre",
			options: {
				filter: true,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const curso = data?.annual_plan[tableMeta?.rowIndex].curso

					return <Typography>{curso.nombre}</Typography>
				},
			},
		},
		{
			name: "mes",
			label: "Mes",
			options: {
				filter: true,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<Typography>
							{MESES[data?.annual_plan[tableMeta?.rowIndex].mes]?.label}
						</Typography>
					)
				},
			},
		},
		{
			name: "mes",
			label: "plataforma",
			options: {
				filter: true,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const curso = data?.annual_plan[tableMeta?.rowIndex].curso

					return <Typography>{curso.plataforma}</Typography>
				},
			},
		},
	]

	const options = {
		// filterType: false,
		selectableRowsHideCheckboxes: true,
		print: false,
		viewColumns: false,
		filter: true,
		download: false,
		selectableRows: "none",
		filterType: "dropdown",
		rowsPerPage: 12,
		// tableBodyHeight: "600px",
		customToolbar: () => (
			<Fragment>
				<PlanningMassiveDialog />
				<PlanningMassiveDialog isDeleted />
			</Fragment>
		),
		textLabels: {
			body: {
				noMatch: `No Hay plan de capacitación de ${
					selectCategory?.description || "categoría desconocida "
				}`,
			},
		},
	}
	if (!filterCourses?.area) return null
	if (loading) return <SkeletonSquareGrid quantity={12} propsG={{ xs: 12, md: 4 }} />

	return (
		<MUIDataTable
			// title={data?.annual_plan[0]?.category}
			data={data?.annual_plan || []}
			columns={columns}
			options={options}
		/>
	)
}
export default PlanningTable
